import { AxiosError, AxiosRequestConfig } from "axios";
import { useReducer } from "react";
import { axiosInstance } from "../services/axios-config/axios-config";

interface State {
  loading: boolean;
  data?: any;
  error?: AxiosError;
}

type Action =
  | { type: "loading" }
  | { type: "completed"; payload: any }
  | { type: "error"; payload: AxiosError };

interface Config {
  method?: "PUT" | "POST" | "DELETE" | "GET";
  options?: AxiosRequestConfig<any>;
  onError?: (error: AxiosError) => void;
  onSuccess?: (data: any) => void;
}

const initialConfig: Config = {
  method: "POST",
  options: {},
};

export default function useMutateData(
  url: string,
  config: Config = initialConfig
) {
  const { method, options, onError, onSuccess } = config;
  const initialState = {
    data: undefined,
    error: undefined,
    loading: false,
  };
  const fetchReducer = (state: State, action: Action): State => {
    switch (action.type) {
      case "loading": {
        return { ...initialState, loading: true };
      }
      case "completed": {
        return { ...initialState, data: action.payload };
      }
      case "error": {
        return { ...initialState, error: action.payload };
      }
      default: {
        return state;
      }
    }
  };

  const [state, dispatch] = useReducer(fetchReducer, initialState);

  const mutate = async (body?: any, dynamicUrl?: string) => {
    dispatch({ type: "loading" });
    try {
      const response = await axiosInstance({
        method: method ?? "POST",
        url: dynamicUrl ?? url,
        data: method !== "DELETE" && body,
        ...options,
      });
      dispatch({ type: "completed", payload: response.data });
      if (onSuccess) {
        onSuccess(response.data);
      }
    } catch (error: any) {
      dispatch({ type: "error", payload: error as AxiosError });
      if (onError) {
        onError(error as AxiosError);
      }
    }
  };

  return { ...state, mutate };
}
